// extracted by mini-css-extract-plugin
export default {"customClass":"BreadCrumbs_customClass__tVCAR"};